import React, { useState } from 'react';
import {
  ListItem,
  Button,
  TextField,
  Paper,
  Grid
} from '@material-ui/core';

function CostCentre({costCentre, onCreate, onUpdate, onCancel}) {

  costCentre = costCentre || {};

  const [CostCentreName, setCostCentreName] = useState(costCentre.name || '');
  const [CostCentreNameError, setCostCentreNameError] = useState('');
  
  const [CostCentreThreshold, setCostCentreThreshold] = useState(costCentre.threshold || '');
  const [CostCentreThresholdError, setCostCentreThresholdError] = useState('');

  function handleNameChange(event) {
    setCostCentreName(event.target.value)
  }

  function handleThresholdChange(event) {
    setCostCentreThreshold(event.target.value)
  }

  function handleSubmit(event) {

    event.preventDefault();

    if (!CostCentreName || CostCentreName.length === 0 || !CostCentreThreshold || CostCentreThreshold < 0) return false;

    const createOrUpdate = costCentre.id
      ? onUpdate({ ...costCentre, name: CostCentreName, threshold: CostCentreThreshold })
      : onCreate({ name: CostCentreName, threshold: CostCentreThreshold });

    createOrUpdate
      .then(resetInputField)
      .catch(error => {
        const message = (error.message === "instance not unique") ? "Duplicate name" : error.message;
        setCostCentreNameError(message);
      })

  }

  function resetInputField() {
    setCostCentreName('');
    setCostCentreNameError('');
    setCostCentreThreshold('');
    setCostCentreThresholdError('');
  }

  return (
    <Paper style={{ margin: 16 }}>
      <ListItem>
        <Grid container>
          <Grid xs={6} md={6} item style={{ paddingRight: 16 }}>
            <TextField
              type="text"
              name={CostCentreName}
              value={CostCentreName}
              placeholder="Cost centre name"
              fullWidth
              {...(CostCentreNameError && {
                error: true,
                helperText: CostCentreNameError
              })}
              onChange={handleNameChange} />
          </Grid>
          <Grid xs={4} md={4} item style={{ paddingRight: 16 }}>
            <TextField
              type="number"
              name={CostCentreThreshold}
              value={CostCentreThreshold}
              placeholder="Escalation threshold"
              fullWidth
              {...(CostCentreThresholdError && {
                error: true,
                helperText: CostCentreThresholdError
              })}
              onChange={handleThresholdChange} />
          </Grid>
          { !costCentre.id && <Grid xs={2} md={2} item>
            <Button
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              fullWidth
            >Create</Button>
          </Grid> }
          { costCentre.id && <>
            <Grid xs={1} md={1} item>
              <Button
                color="primary"
                variant="contained"
                style={{marginRight: '6px'}}
                onClick={handleSubmit}
                fullWidth
              >Save</Button>
              </Grid>
              <Grid xs={1} md={1} item>
              <Button
                color="primary"
                style={{marginLeft: '6px'}}
                variant="outlined"
                onClick={() => onCancel(costCentre)}
                // fullWidth
              >Cancel</Button>
            </Grid>
          </>}
        </Grid>
      </ListItem>
    </Paper>
  );
}
export default CostCentre;